"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var JoinCallButtonTimeRangeWarning = function JoinCallButtonTimeRangeWarning(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("p", {
    className: className
  }, "The \"Join call\" button will be enabled ", _utils.JoinCallGracePeriodMinutes.before, " minutes before the scheduled start time. If the button is not enabled, try refreshing the page or closing other Monument tabs.");
};
var _default = JoinCallButtonTimeRangeWarning;
exports.default = _default;